import React, { useState } from 'react'

import { apiURL } from '../../utilities/URLs'
import { useNavigate } from 'react-router-dom'
import { company } from '../../utilities/CustomerData'

export default function RequestPasswordReset() {
  const navigate = useNavigate()

  const [email, setEmail] = useState('')
  const [last4SSN, setLast4SSN] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState('')

  const handleSubmit = async () => {
    if(email.length > 0 && last4SSN.length > 0) {
      setLoading('Requesting Reset...')

      const updatedPasswordResponse = await fetch(`${apiURL}/api/requestPasswordReset?email=${encodeURIComponent(email)}&last4SSN=${encodeURIComponent(last4SSN)}`)

      const updatedPasswordData = await updatedPasswordResponse.json()

      if(updatedPasswordData.response.error) {
        setLoading('')
        setError(updatedPasswordData.response.error)
        setTimeout(() => {
          setError('')
        }, 2000)
      } else
        navigate(`/resetPassword/${updatedPasswordData.response.resetToken}`)
    } else {
      setError('Please Provide Email and SSN')
      setTimeout(() => {
        setError('')
      }, 2000)
    }
  }

  return (
    <div className='flex flex-col items-center justify-center h-svh'>
      <img className='w-60 mb-28' src={company.companyLogoURL} alt='setcLogo' />
      <div className='w-full max-w-xs p-8 bg-white rounded-lg shadow mb-28 text-center'>
        <h1 className='mb-10 text-center'>Reset Password Request</h1>
        <div className='mb-4'>
          <label htmlFor='email' className='block mb-2 text-sm font-bold text-gray-700 text-left'>
            Email
          </label>
          <input
            type='email'
            id='email'
            className='w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className='mb-4'>
          <label htmlFor='last4SSN' className='block mb-2 text-sm font-bold text-gray-700 text-left'>
            Last 4 SSN
          </label>
          <input
            type='password'
            id='last4SSN'
            className='w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline'
            value={last4SSN}
            onChange={(e) => setLast4SSN(e.target.value)}
            required
          />
        </div>
        <div className='flex justify-center'>
          <button onClick={() => handleSubmit()} type='submit' className='px-4 py-2 font-bold text-white rounded bg-primaryColor hover:bg-primaryDarkColor transition duration-200'>
            Request Reset
          </button>
        </div>
        {loading.length > 0 && (
          <p className='mt-5'>{loading}</p>
        )}
        {error.length > 0 && (
          <p className='text-red-600 mt-5'>{error}</p>
        )}
      </div>
    </div>
  )
}